import { Box, Button, createStyles, lighten, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

interface TnTextToggleProps {
  onOption: string;
  offOption: string;
  value: string;
  onChange: (value: string) => void;
  disableToggleOn?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'relative',
      display: 'inline-flex',
      backgroundColor: '#FFFFFF',
      borderRadius: '20px',
      width: 'fit-content',
      gap: '2px',
      border: `2px solid #E0E0E0`,
      marginLeft: 2,
      marginRight: 2,
    },
    button: {
      textTransform: 'none',
      borderRadius: '18px',
      padding: theme.spacing(0.5, 1.5),
      border: 'none',
      fontSize: '14px',
      fontWeight: 400,
      minWidth: 'auto',
      transition: 'all 0.2s ease',
      '&.active': {
        backgroundColor: lighten(theme.palette.primary.main, 0.85),
        color: theme.palette.primary.main,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        fontWeight: 500,
        border: `2px solid ${theme.palette.primary.main}`,
        margin: '-2px',
      },
      '&.inactive': {
        backgroundColor: '#FFFFFF',
        color: '#757575',
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.3)',
        },
      },
    },
  }),
);

export default function TnTextToggle({
  onOption,
  offOption,
  value,
  onChange,
  disableToggleOn = false,
}: TnTextToggleProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Button
        className={`${classes.button} ${value === onOption ? 'active' : 'inactive'}`}
        onClick={() => onChange(onOption)}
        disableRipple
        disabled={disableToggleOn}
      >
        {onOption}
      </Button>
      <Button
        className={`${classes.button} ${value === offOption ? 'active' : 'inactive'}`}
        style={{
          backgroundColor: disableToggleOn && value === offOption ? '#EFEFEF' : undefined,
          borderColor: disableToggleOn && value === offOption ? '#E0E0E0' : undefined,
          color: disableToggleOn && value === offOption ? '#B5B5B5' : undefined,
        }}
        onClick={() => onChange(offOption)}
        disableRipple
      >
        {offOption}
      </Button>
    </Box>
  );
}
